import { Injectable } from '@angular/core';
import { ContextService } from 'projects/cross-study-portal-lib/src/public-api';
import { PermissionService } from 'projects/cross-study-portal-lib/src/lib/services/permission.service';
import {
  ROUTE_ROLES,
  ROUTE_SITES,
  ROUTE_USERS,
  ROUTE_GLOBAL_USERS,
} from '../route.constants';
import { MenuOption } from '../interfaces/menu-option';

@Injectable({
  providedIn: 'root',
})
export class MenuOptionService {
  private readonly imagesPath: string = '/assets/images';
  private _navOptions: MenuOption[] = [];

  getMenuOptions(): MenuOption[] {
    return this._navOptions;
  }

  constructor(private context: ContextService, permissionService: PermissionService) {
    this._navOptions = [
      {
        landingPageTitle: 'sites',
        description: 'sitesDescription',
        landingPageSubtitle: '',
        url: ROUTE_SITES,
        imageSrcPath: `${this.imagesPath}/sites-card.svg`,
        disabled: false,
        changesMade: false,
        basePath: '/',
        forceActive: false,
        visible: permissionService.canReadSites() || permissionService.canEditSites(),
        sideNavTitle: 'sites',
      },
      {
        landingPageTitle: 'rolesandpermissions',
        description: '',
        landingPageSubtitle: '',
        url: ROUTE_ROLES,
        imageSrcPath: `${this.imagesPath}/roles-card.svg`,
        disabled: false,
        changesMade: false,
        basePath: '/',
        forceActive: false,
        visible: permissionService.canManageRoles(),
        sideNavTitle: 'rolesandpermissions',
      },
      {
        landingPageTitle: 'cspUserManagement',
        description: '',
        landingPageSubtitle: '',
        url: ROUTE_USERS,
        imageSrcPath: `${this.imagesPath}/user-management.svg`,
        disabled: false,
        changesMade: false,
        basePath: '/',
        forceActive: false,
        visible: permissionService.canManageUsers(),
        sideNavTitle: 'cspUserManagement',
      },
      {
        landingPageTitle: 'userManagement',
        description: '',
        landingPageSubtitle: '',
        url: ROUTE_GLOBAL_USERS,
        imageSrcPath: `${this.imagesPath}/global-user-list.svg`,
        disabled: false,
        changesMade: false,
        basePath: '/',
        forceActive: false,
        visible: permissionService.canManageUsers(),
        sideNavTitle: 'userManagement',
      },
    ];
  }
}
